export const categories = [
  {
    slug: 'romance',
    name: '恋爱韩漫',
    description: '浪漫甜蜜的韩国恋爱漫画，感受心动瞬间',
    icon: 'ri-heart-line',
  },
  {
    slug: 'fantasy',
    name: '奇幻韩漫',
    description: '穿越异世界、魔法与剑的奇幻冒险故事',
    icon: 'ri-magic-line',
  },
  {
    slug: 'action',
    name: '热血韩漫',
    description: '热血沸腾的战斗与成长故事',
    icon: 'ri-fire-line',
  },
  {
    slug: 'comedy',
    name: '搞笑韩漫',
    description: '轻松搞笑的日常喜剧，笑到停不下来',
    icon: 'ri-emotion-laugh-line',
  },
  {
    slug: 'horror',
    name: '悬疑恐怖',
    description: '扣人心弦的悬疑推理与惊悚故事',
    icon: 'ri-ghost-line',
  },
  {
    slug: 'drama',
    name: '剧情韩漫',
    description: '深刻动人的剧情向韩漫作品',
    icon: 'ri-film-line',
  },
  {
    slug: 'school',
    name: '校园韩漫',
    description: '青春校园里的友情与成长故事',
    icon: 'ri-building-line',
  },
  {
    slug: 'bl',
    name: 'BL韩漫',
    description: '唯美精致的BL韩漫作品合集',
    icon: 'ri-star-line',
  },
];

export const featuredComics = [
  {
    id: 1,
    title: '她与他的秘密花园',
    category: 'romance',
    categoryName: '恋爱韩漫',
    description: '一段发生在首尔江南区的浪漫爱情故事，两个性格迥异的年轻人在偶然的机会下相遇，从此展开了甜蜜而又充满波折的恋爱旅程。',
    rating: 9.2,
    chapters: 86,
    status: '连载中',
    coverSeq: 'comic-cover-01',
  },
  {
    id: 2,
    title: '异世界剑圣传奇',
    category: 'fantasy',
    categoryName: '奇幻韩漫',
    description: '普通上班族意外穿越到剑与魔法的异世界，凭借现代知识与不屈意志，一步步成长为最强剑圣的热血故事。',
    rating: 9.5,
    chapters: 124,
    status: '连载中',
    coverSeq: 'comic-cover-02',
  },
  {
    id: 3,
    title: '格斗之王',
    category: 'action',
    categoryName: '热血韩漫',
    description: '天才格斗少年踏上巅峰之路，每一场战斗都是生与死的较量，用拳头捍卫尊严与荣耀！',
    rating: 9.0,
    chapters: 67,
    status: '连载中',
    coverSeq: 'comic-cover-03',
  },
  {
    id: 4,
    title: '办公室喜剧人',
    category: 'comedy',
    categoryName: '搞笑韩漫',
    description: '几个奇葩同事的日常搞笑故事，让你在捧腹大笑中感受职场生活的酸甜苦辣。',
    rating: 8.8,
    chapters: 45,
    status: '已完结',
    coverSeq: 'comic-cover-04',
  },
  {
    id: 5,
    title: '深夜的访客',
    category: 'horror',
    categoryName: '悬疑恐怖',
    description: '一个独居女孩搬进廉价公寓后，每夜都有奇怪的访客敲门。真相远比想象中更加恐怖...',
    rating: 9.1,
    chapters: 38,
    status: '连载中',
    coverSeq: 'comic-cover-05',
  },
  {
    id: 6,
    title: '时光倒流的咖啡馆',
    category: 'drama',
    categoryName: '剧情韩漫',
    description: '一间神秘咖啡馆里，喝下特制咖啡就能回到过去。每个客人都带着无法释怀的遗憾而来...',
    rating: 9.4,
    chapters: 52,
    status: '已完结',
    coverSeq: 'comic-cover-06',
  },
  {
    id: 7,
    title: '我们的青春手册',
    category: 'school',
    categoryName: '校园韩漫',
    description: '高中最后一个夏天，一群好友决定在毕业前完成各自的青春清单，留下最珍贵的回忆。',
    rating: 9.3,
    chapters: 60,
    status: '已完结',
    coverSeq: 'comic-cover-07',
  },
  {
    id: 8,
    title: '月光下的约定',
    category: 'bl',
    categoryName: 'BL韩漫',
    description: '两个音乐系学生在月光下的琴房里许下的约定，一段唯美动人的BL故事。',
    rating: 9.6,
    chapters: 72,
    status: '连载中',
    coverSeq: 'comic-cover-08',
  },
];

export const articles = [
  {
    id: 1,
    title: '2025年最值得下载的韩漫APP推荐',
    summary: '随着韩漫在全球范围内的流行，越来越多的读者开始寻找优质韩漫阅读APP。本文为您整理了2025年最值得下载的几款韩漫APP，让您随时随地畅享韩漫世界。',
    content: `<p>近年来，韩国漫画（简称"韩漫"）在全球范围内掀起了一股热潮。与传统的日式漫画不同，韩漫以其独特的纵向滚动阅读方式、精美的全彩画风和引人入胜的剧情，吸引了大量读者。</p>
    <p>对于中文读者来说，找到一款好用且资源丰富的韩漫APP尤为重要。本文将为您详细介绍2025年最值得下载的几款韩漫APP。</p>
    <h3>1. 韩漫之家APP</h3>
    <p>韩漫之家是目前最受欢迎的韩漫阅读平台之一，拥有海量的韩漫资源库，涵盖恋爱、奇幻、热血、搞笑、悬疑等多种类型。支持离线下载功能，让您在没有网络的情况下也能畅快阅读。</p>
    <h3>2. 快看漫画</h3>
    <p>快看漫画作为国内领先的漫画平台，也收录了大量优质韩漫作品。界面简洁美观，阅读体验流畅，是韩漫爱好者的不错选择。</p>
    <h3>3. PODO漫画</h3>
    <p>PODO漫画专注于引进韩国正版漫画，画质高清，翻译质量优秀。虽然部分内容需要付费，但对于追求高品质阅读体验的读者来说非常值得。</p>
    <h3>如何选择适合自己的韩漫APP？</h3>
    <p>选择韩漫APP时，建议考虑以下几个方面：资源丰富程度、阅读体验、离线下载功能、更新速度以及是否支持免费阅读。韩漫之家在这几方面都表现出色，是绝大多数韩漫爱好者的首选。</p>`,
    category: 'guide',
    categoryName: '使用指南',
    date: '2025-12-15',
    readCount: 12830,
    author: '韩漫之家编辑',
    coverSeq: 'article-cover-01',
  },
  {
    id: 2,
    title: '韩漫离线下载全攻略：随时随地看韩漫',
    summary: '想知道如何将韩漫下载到手机离线观看吗？本文为您提供完整的韩漫离线下载教程，包括韩漫之家APP的详细操作步骤和小技巧。',
    content: `<p>在通勤路上、旅行途中或是网络信号不好的地方，能够离线观看韩漫是非常实用的功能。本文将详细介绍如何使用韩漫之家APP进行离线下载。</p>
    <h3>韩漫离线下载步骤</h3>
    <p><strong>第一步：</strong>下载并安装韩漫之家APK。您可以在韩漫之家官网首页找到最新版本的APK下载链接。</p>
    <p><strong>第二步：</strong>打开韩漫之家APP，浏览或搜索您想看的韩漫作品。</p>
    <p><strong>第三步：</strong>进入漫画详情页，点击"离线下载"按钮。您可以选择下载单话或批量下载多话。</p>
    <p><strong>第四步：</strong>等待下载完成。下载速度取决于您的网络状况和漫画文件大小。</p>
    <p><strong>第五步：</strong>下载完成后，您可以在"我的下载"中查看所有已下载的韩漫，随时随地离线阅读。</p>
    <h3>离线下载小技巧</h3>
    <p>1. 建议在WiFi环境下进行批量下载，以节省手机流量。</p>
    <p>2. 定期清理已看完的缓存漫画，释放手机存储空间。</p>
    <p>3. 韩漫之家支持SD卡存储，可以将下载内容转移到扩展存储中。</p>`,
    category: 'guide',
    categoryName: '使用指南',
    date: '2025-11-28',
    readCount: 9650,
    author: '韩漫之家编辑',
    coverSeq: 'article-cover-02',
  },
  {
    id: 3,
    title: '韩国漫画为何风靡全球？深度解析韩漫魅力',
    summary: '从画风到叙事，从文化到技术，全面解析韩国漫画为何能在短短几年内征服全球读者的心。',
    content: `<p>过去十年间，韩国漫画产业经历了爆发式增长。从韩国本土到亚洲各国，再到欧美市场，韩漫的热度持续攀升。那么，韩漫到底有什么独特的魅力？</p>
    <h3>1. 全彩竖屏阅读体验</h3>
    <p>与传统黑白漫画不同，韩漫采用全彩绘制，画面更加生动精美。同时，专为手机设计的竖屏滚动阅读方式，让读者可以单手操作，极大提升了移动端阅读的舒适度。</p>
    <h3>2. 紧凑的剧情节奏</h3>
    <p>韩漫通常采用短小精悍的章节结构，每话内容紧凑有力，悬念设置巧妙，让人欲罢不能。"追更"成为韩漫读者的日常。</p>
    <h3>3. 多元化的题材</h3>
    <p>从浪漫爱情到职场奋斗，从奇幻冒险到社会现实，韩漫题材极为丰富。无论你喜欢什么类型，总能在韩漫中找到心仪的作品。</p>
    <h3>4. 强大的IP生态</h3>
    <p>许多热门韩漫被改编为韩剧、电影、游戏等，形成了强大的跨媒体IP生态。《梨泰院Class》《女神降临》等韩剧都源自韩漫改编。</p>
    <h3>5. 技术与平台的推动</h3>
    <p>韩国发达的移动互联网基础设施，以及KakaoPage、Naver Webtoon等平台的崛起，为韩漫的传播提供了强大的技术和渠道支持。</p>`,
    category: 'news',
    categoryName: '韩漫资讯',
    date: '2025-11-10',
    readCount: 15200,
    author: '韩漫之家编辑',
    coverSeq: 'article-cover-03',
  },
  {
    id: 4,
    title: '2025年度最受欢迎韩漫TOP10排行榜',
    summary: '根据读者投票和阅读数据，我们整理出了2025年度最受欢迎的十部韩漫作品，快来看看有没有你正在追的！',
    content: `<p>2025年即将过去，韩漫之家根据全年的读者投票、阅读量、评论数等多维度数据，整理出了本年度最受欢迎的十部韩漫作品。</p>
    <h3>TOP 1：《月光下的约定》</h3>
    <p>以9.6的高分荣登榜首，这部BL作品以其细腻的情感描写和唯美的画风征服了无数读者。</p>
    <h3>TOP 2：《异世界剑圣传奇》</h3>
    <p>评分9.5，这部奇幻热血作品以其宏大的世界观和精彩的战斗场面，成为2025年最火爆的韩漫之一。</p>
    <h3>TOP 3：《时光倒流的咖啡馆》</h3>
    <p>评分9.4，这部剧情向作品以独特的设定和感人至深的故事，赢得了读者的广泛好评。</p>
    <h3>TOP 4-10完整榜单</h3>
    <p>4. 《我们的青春手册》 - 评分9.3</p>
    <p>5. 《她与他的秘密花园》 - 评分9.2</p>
    <p>6. 《深夜的访客》 - 评分9.1</p>
    <p>7. 《格斗之王》 - 评分9.0</p>
    <p>8. 《办公室喜剧人》 - 评分8.8</p>
    <p>9. 《星辰坠落之夜》 - 评分8.7</p>
    <p>10. 《末日生存指南》 - 评分8.6</p>`,
    category: 'news',
    categoryName: '韩漫资讯',
    date: '2025-12-01',
    readCount: 21050,
    author: '韩漫之家编辑',
    coverSeq: 'article-cover-04',
  },
  {
    id: 5,
    title: '韩漫APK安装教程：安卓手机完美安装指南',
    summary: '详细的韩漫APK安装教程，包括安全设置、安装步骤和常见问题解决方案，让您轻松在安卓手机上安装韩漫之家APP。',
    content: `<p>对于安卓手机用户来说，通过APK安装应用是一种常见的操作。本文将详细介绍如何安全地在您的安卓手机上安装韩漫之家APK。</p>
    <h3>安装前准备</h3>
    <p>在安装韩漫之家APK之前，请确保您的手机满足以下条件：Android 6.0及以上系统版本、至少100MB可用存储空间、允许安装未知来源应用。</p>
    <h3>安装步骤</h3>
    <p><strong>第一步：</strong>从韩漫之家官网下载最新版APK文件。</p>
    <p><strong>第二步：</strong>打开手机"设置" → "安全" → 开启"未知来源"或"允许安装未知应用"选项。</p>
    <p><strong>第三步：</strong>使用文件管理器找到下载的APK文件，点击安装。</p>
    <p><strong>第四步：</strong>按照屏幕提示完成安装，等待安装完成即可。</p>
    <h3>常见问题</h3>
    <p><strong>Q：安装时提示"解析包错误"怎么办？</strong></p>
    <p>A：请重新下载APK文件，确保文件下载完整。同时检查您的Android系统版本是否满足要求。</p>
    <p><strong>Q：安装后闪退怎么办？</strong></p>
    <p>A：尝试清除应用缓存，或卸载后重新安装最新版本。</p>`,
    category: 'guide',
    categoryName: '使用指南',
    date: '2025-10-20',
    readCount: 18700,
    author: '韩漫之家编辑',
    coverSeq: 'article-cover-05',
  },
  {
    id: 6,
    title: '从韩剧到韩漫：改编作品的无限可能',
    summary: '越来越多的热门韩剧源自韩漫改编，本文将盘点那些从漫画走向荧幕的成功案例，探讨韩漫IP的跨界魅力。',
    content: `<p>近年来，韩漫改编韩剧已成为韩国影视产业的一大趋势。从《梨泰院Class》到《女神降临》，这些改编作品不仅收获了高收视率，还推动了原作漫画的全球传播。</p>
    <h3>《梨泰院Class》</h3>
    <p>这部由同名韩漫改编的韩剧，讲述了年轻人们在梨泰院小街上的创业与复仇故事。剧集播出后全球大热，也让更多人开始关注韩漫这一文化形式。</p>
    <h3>《女神降临》</h3>
    <p>讲述了一个通过化妆变身"女神"的女孩的成长故事。漫画本身就拥有极高人气，改编成韩剧后再次引爆话题。</p>
    <h3>《Sweet Home》</h3>
    <p>这部末日恐怖题材的韩漫改编剧，以精良的特效和紧凑的剧情获得了国际观众的认可，成为Netflix上最受欢迎的韩国原创剧集之一。</p>
    <h3>韩漫IP的未来</h3>
    <p>随着韩漫品质的不断提升和全球化战略的推进，未来将有更多优秀的韩漫作品被改编为影视、游戏等多元化内容，韩漫IP的商业价值和文化影响力将持续扩大。</p>`,
    category: 'news',
    categoryName: '韩漫资讯',
    date: '2025-09-15',
    readCount: 11340,
    author: '韩漫之家编辑',
    coverSeq: 'article-cover-06',
  },
];

export const faqs = [
  {
    question: '韩漫之家APK是否免费下载？',
    answer: '是的，韩漫之家APK完全免费下载。您可以直接从我们的官方网站下载最新版本的APK安装包，无需支付任何费用。下载安装后即可免费浏览海量韩漫资源。',
  },
  {
    question: '如何将韩漫离线下载到手机？',
    answer: '在韩漫之家APP中，找到您想下载的漫画，进入详情页后点击"离线下载"按钮即可。支持单话下载和批量下载两种方式，下载完成后可在"我的下载"中离线观看。',
  },
  {
    question: '韩漫之家支持哪些手机系统？',
    answer: '韩漫之家目前支持Android 6.0及以上版本的安卓手机。iOS版本的开发正在进行中，敬请期待。您也可以通过手机浏览器访问我们的网页版进行阅读。',
  },
  {
    question: '下载的韩漫会占用多少手机存储空间？',
    answer: '每话韩漫大约占用5-15MB的存储空间，具体取决于漫画的页数和画质。建议定期清理已看完的缓存文件，或使用SD卡扩展存储。韩漫之家APP支持将下载内容保存到SD卡。',
  },
  {
    question: '韩漫之家有广告吗？',
    answer: '韩漫之家采用轻度广告模式，确保不会过度影响您的阅读体验。我们也在不断优化广告投放策略，在保证平台运营的同时，为读者提供最佳的阅读环境。',
  },
  {
    question: '如何获取最新的韩漫更新通知？',
    answer: '您可以在韩漫之家APP中订阅喜欢的漫画作品，当有新章节更新时，系统会自动推送通知提醒您。此外，也可以关注我们的官方社交媒体账号获取最新资讯。',
  },
];

export const testimonials = [
  {
    id: 1,
    name: '小雨',
    avatar: 'ri-user-3-line',
    rating: 5,
    content: '韩漫之家真的太方便了！离线下载功能让我在坐地铁的时候也能看韩漫，画质清晰，更新速度也很快，强烈推荐！',
    date: '2025-12-20',
  },
  {
    id: 2,
    name: '漫画迷小王',
    avatar: 'ri-user-3-line',
    rating: 5,
    content: '用了半年多了，资源非常丰富，各种类型的韩漫都有。界面也很简洁好用，是我用过的最好的韩漫APP。',
    date: '2025-12-10',
  },
  {
    id: 3,
    name: '追漫少女',
    avatar: 'ri-user-3-line',
    rating: 5,
    content: '从朋友那里知道韩漫之家的，下载安装超级简单。现在每天睡前都要看几话韩漫，已经离不开了~',
    date: '2025-11-28',
  },
  {
    id: 4,
    name: '宅男阿杰',
    avatar: 'ri-user-3-line',
    rating: 4,
    content: '资源挺全的，更新也及时。离线下载功能对于经常出差的我来说简直是刚需，希望以后能出iOS版本。',
    date: '2025-11-15',
  },
];

export const stats = [
  { label: '韩漫资源', value: '10,000+', suffix: '部' },
  { label: '活跃用户', value: '500,000+', suffix: '人' },
  { label: '累计下载', value: '2,000,000+', suffix: '次' },
  { label: '用户评分', value: '4.8', suffix: '/5.0' },
];